import * as React from 'react';
import './button.css';
import { button_hover, button_disabled, icon_button_no_hover, icon_dim } from './button.styles';

export interface Icon_Button_Props {
    src: string;
    alt: string;
    color: string;
    className?: string;
    disabled: boolean;
    onClick: Function;
}

export interface Button_State {
    hovering: boolean;
    clicked: boolean;
}

class IconButton extends React.PureComponent<Icon_Button_Props, Button_State> {



    constructor(props: Icon_Button_Props) {
        super(props)

        this.state = {
            hovering: false,
            clicked: false
       };
    }

    handleMouseEnter = () => this.setState({hovering : true});
    handleMouseLeave = () => this.setState({hovering : false});
    handleMouseUp = () => this.setState({clicked: false});
    handleMouseDown = () => this.setState({clicked: true});

    render() {
        return (
            <div
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
                onMouseUp={this.handleMouseUp}
                onMouseDown={this.handleMouseDown}
                className={this.props.className}
                onClick={this.clickHandler.bind(this, this.props.disabled, this.props.onClick)}
                style={
                    Object.assign({
                        ...icon_button_no_hover,
                        'backgroundColor': this.props.color
                        
                    }, 
                    (!this.state.hovering) ? {} : button_hover,
                    this.props.disabled ? button_disabled : {})
                }>
                <img style={icon_dim} src={this.props.src} alt={this.props.alt}></img>
            </div>
        )
    }

    clickHandler = (disabled: boolean, onClick: Function, event: any) => {
        if (!disabled) onClick();
    }
}

export default IconButton;


// WEBPACK FOOTER //
// ./src/custom_components/button/icon_button.tsx